import React, { useState, useRef } from "react";
import Slider from "react-slick";

export default function VisitSlider({ className, data, title, subTitle }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);

  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentIndex(newIndex);
  };

  const getImageUrl = (title) => {
    const base = title
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
    return `/img/explore/explore-${base}.webp`;
  };

  const handleNavClick = (index) => {
    setCurrentIndex(index);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: handleBeforeChange,
    adaptiveHeight: true,
  };

  return (
    <div className={`explore-slider ${className}`}>
      <div className="container my-4">
        <div className="row text-center mb-4 pb-5">
          <div className="col-12">
            <h1 className="color-purple">{title}</h1>
            <p>{subTitle}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 d-none d-md-block pe-4">
            <ul className="slider-nav">
              {data.map((item, index) => (
                <li
                  key={index}
                  className={`cursor-pointer ${
                    index === currentIndex ? "active" : ""
                  }`}
                  onClick={() => handleNavClick(index)}
                  style={{ cursor: "pointer" }}
                >
                  {item.title}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-12 col-md-8">
            <Slider
              ref={sliderRef}
              {...sliderSettings}
              initialSlide={currentIndex}
            >
              {data.map((item, index) => (
                <div key={index}>
                  <div className="px-2">
                    <h2 className="d-block d-md-none text-center mb-3">
                      {item.title}
                    </h2>

                    <img
                      src={getImageUrl(item.title)}
                      alt={item.title}
                      className="img-fluid rounded-4 mb-4"
                    />

                    <p
                      className="description mb-3"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>

                    {(item.distance === 0 || item.distance > 0) && (
                      <span className="color-purple">
                        {item.distance === 0 ? (
                          <>
                            <i className="fa-solid fa-hotel"></i> On-property
                            experience
                          </>
                        ) : (
                          <>
                            <i className="fa fa-map-marker"></i> {item.distance}{" "}
                            miles
                          </>
                        )}
                        {item.url && <span className="mx-2">|</span>}
                      </span>
                    )}

                    {item.url && (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        Learn more <i className="fa fa-external-link"></i>
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
